import Swal from 'sweetalert2';

export const showError = (message) => {
  Swal.fire({
    icon: 'error',
    title: 'Oops!',
    text: message,
    confirmButtonColor: '#6366f1',
  });
};
